// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__HBG6C","content":"ManualTimeModal_content__2h1uP"};